module.exports = __webpack_public_path__ + "images/program/heartPixel.9703badf.svg";